<div style="height: 100vh">
  @if (!pageLoaded) {
  <div class="loading-indicator">
    <mat-spinner style="margin:0 auto; margin-top: -37.5px;"></mat-spinner>
    <div class="waitText">Finalising your payment..</div>
  </div>
  } @else {
  <div class="container" [@inAnimation]>
    <div class="messageBox">
      @if (branchLogo != 'null') {
      <p>
        <img src="https://sings-media.s3.eu-west-2.amazonaws.com/logo/{{ branchLogo }}" width="155px" style="mix-blend-mode: multiply;">
      </p>
      }

      <h1 class="blackFont">
        @if (customerTitle != '') {
        <span>{{ customerTitle }} </span>
        }
        <span>{{ customerName }}</span>
      </h1>

      <h2>
        Thank you for your payment of
        <span class="blackFont">{{ amount | currency: currency }}</span>
        @if (description != '') {
        for '<span class="blackFont">{{ description }}</span>'
        }.
      </h2>

      @if (!fakeEmail) {
      <h2>You will receive a receipt shortly.</h2>
      } @else {
      <h2>The proof of payment will be sent directly to the shop.</h2>
      }

      @if (branchEmail && branchPhone) {
      <h2 style="max-width: 700px;">
        If you have any questions, please contact us on
        <span class="blackFont">{{ branchEmail }}</span> or by phone
        <span class="blackFont">{{ branchPhone }}</span>.
      </h2>
      } @else if (branchEmail) {
      <h2 style="max-width: 700px;">
        If you have any questions, please contact us on
        <span class="blackFont">{{ branchEmail }}</span>.
      </h2>
      } @else if (branchPhone) {
      <h2 style="max-width: 700px;">
        If you have any questions, please contact us by phone
        <span class="blackFont">{{ branchPhone }}</span>.
      </h2>
      }

      <br>
      <h3>Kind Regards,</h3>
      <h3>{{ branchName }} Team</h3>

      @if (systemMessage != '') {
      <br><br>
      <h3><u>{{ systemMessage }}</u></h3>
      }
    </div>
  </div>
  }
</div>